import { type MonitorIdentifier } from 'app/redux/viewerConfiguration/reducer';

export default async function getMonitorIdentifier(): Promise<MonitorIdentifier> {
  // Todo, handle permission not allowed for 'window-management'
  try {
    // Retrieve screen info from user, user will be prompted to allow access to screen info.
    // @ts-ignore
    return (await window.getScreenDetails())?.currentScreen?.label;
  } catch (e) {
    console.error('Error getting display name:', e);
  }
  // We use default here because on web we might not be able to retrieve the display name from electron
  return 'NOT_ACCESSIBLE';

  //   const { width: screenWidth, height: screenHeight, orientation } = window.screen;
  //   const isRotated = orientation.angle % 180 !== 0;
  //   const realScreenWidth = isRotated ? screenHeight : screenWidth;
  //   const realScreenHeight = isRotated ? screenWidth : screenHeight;
  //   return `${displayName}:${realScreenWidth}x${realScreenHeight}`;
}
